export const css = {
	inlinePopupWrapper: '_1sej1l6Q',
	inlinePopupContent: 'SVLNxv1B',
	' _key': 'base-widgets/inline-trigger-popup'
};

export default css;
